module.exports = __webpack_public_path__ + "img/netfusion_platform_diagram.a4522e51.gif";